import Keycloak from 'keycloak-js';

const keycloak = new Keycloak({
  url: 'https://dashboard.chuyenkhoan.com/auth', // URL gốc của Keycloak
  realm: 'ckpay',                      // Tên realm
  clientId: 'ckdashboard'              // Client ID đã tạo trong Keycloak
});

export default keycloak;
